import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import AuthenticationService from "@app/authentication/authenticationService";

interface AuthenticationCallbackState {
  foo: string;
}

type AuthenticationCallbackProps = RouteComponentProps;

class AuthenticationCallback extends React.Component<AuthenticationCallbackProps, AuthenticationCallbackState> {

  constructor(props: AuthenticationCallbackProps) {
    super(props);
  }

  public async componentDidMount() {
    try {
      await AuthenticationService.getInstance().signInRedirectCallback();
      const redirectUrl = sessionStorage.getItem("LoginRedirect");
      window.location.replace(redirectUrl);
    } catch (e) {
      await AuthenticationService.getInstance().removeUser();
      throw e;
    }
  }

  public render() {
    return (
      <>
        <div className="pt-3 ps-3">
          <LoadingSpinner />
        </div>
      </>
    );
  }

}

export default AuthenticationCallback as React.ComponentClass<AuthenticationCallbackProps>;
